export default {
    // apiURL: ((window.location.origin).indexOf('localhost') === -1 && (window.location.origin).indexOf('192.168') === -1) ? window.location.origin.replace('.bacs', '-api.bacs') + '/API/' : 'https://dev-api.bacs.ooo/API/',
    // apiURL: 'http://192.168.1.46/API/',
    apiURL: import.meta.env.VITE_API_URL || 'https://dragons-api.bacs.ooo/API/',
    // 開発環境
    // apiURL: 'https://dev-api.bacs.ooo/API/',
    // NB デモ環境
    // apiURL: 'https://nb-api.bacs.ooo/API/',
    // NB テスト環境
    // apiURL: 'https://dev-nb-api.bacs.ooo/API/',
    // 巨人 ステージング環境
    // apiURL: 'https://stg-giants-api.bacs.ooo/API/',
    // 巨人 本番環境
    // apiURL: 'https://giants-api.bacs.ooo/API/',
    // NB 開発環境
    // apiURL: 'https://dev-osaki-api.bacs.ooo/API/',
    accessControl: {
        batting: true,
        scout: false
    },
    // チーム変更プルダウンの並び替え用（暫定。巨人が1番目、セリーグの2016順位、パ・リーグの2016順位）
    pulldownTeamList: [
        'CHU_DRA',
        'YOM_GIA',
        'HIR_CAR',
        'BAY_STA',
        'HAN_TIG',
        'YAK_SWA',
        'HOK_FIG',
        'SOF_HAW',
        'CHI_MAR',
        'SAI_LIO',
        'TOH_GOL',
        'ORI_BUF',
        'KUF_HAY',
        'OIS_NII'
    ],
    typesOfBall: {
        // 'FourSeamFastball': {
        //     name: 'フォーシーム',
        //     stroke: '#fe37ff',
        //     fill: '#fc9fff',
        //     dragons_marker_r: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
        //     dragons_marker_l: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
        //     marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        // },
        // 'OneSeamFastball': {
        //     name: 'ワンシーム',
        //     stroke: '#ff3737',
        //     fill: '#ff9f9f',
        //     dragons_marker_r: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
        //     dragons_marker_l: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
        //     marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        // },

        'Fastball': {
            name: '速球',
            stroke: '#fb3a3a',
            fill: '#fc9f9f',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
            dragons_marker_r: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
            dragons_marker_l: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#333"></circle>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'TwoSeamFastball': {
            name: 'ツーシーム',
            fill: '#3da2f5',
            stroke: '#2196F3',
            dragons_marker_r: '<path d="M1,1 l6,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M7,1 l0,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'Slider': {
            name: 'スライダー',
            stroke: '#3a71fb',
            fill: '#6f97fa',
            dragons_marker_r: '<path d="M1,4 L7,1 L7,7 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M7,4 L1,1 L1,7 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'Curveball': {
            name: 'カーブ',
            stroke: '#55c114',
            fill: '#a1d780',
            dragons_marker: '<path d="M4,1 L1,7 L7,7 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_r: '<path d="M4,1 L1,7 L7,7 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M4,1 L1,7 L7,7 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'

        },
        'Splitter': {
            name: 'スプリッター',
            stroke: '#a04dca',
            fill: '#c280e2',
            dragons_marker_r: '<path d="M1,1 l6,0 l0,6, l-6,0 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M1,1 l6,0 l0,6, l-6,0 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'ChangeUp': {
            name: 'チェンジアップ',
            stroke: '#e6951d',
            fill: '#f7e427',
            dragons_marker: '<path d="M4,0.5 l3.5,3.5 l-3.5,3.5 l-3.5,-3.5 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_r: '<path d="M4,0.5 l3.5,3.5 l-3.5,3.5 l-3.5,-3.5 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M4,0.5 l3.5,3.5 l-3.5,3.5 l-3.5,-3.5 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'Sinker': {
            name: 'シンカー',
            stroke: '#38a3cc',
            fill: '#5cd1e4',
            dragons_marker_r: '<path d="M1,1 l6,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M7,1 l0,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'Cutter': {
            name: 'カットボール',
            stroke: '#e27908',
            fill: '#ffb748',
            dragons_marker_r: '<path d="M7,1 l0,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M1,1 l6,6 l-6,0 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'KnuckleBall': {
            name: 'ナックル',
            stroke: '#666666',
            fill: '#999999'
        },
        'Other': {
            name: 'その他',
            stroke: '#999999',
            fill: '#ffffff',
            dragons_marker: '<path d="M4,0.5 l1.25,2.5 l2.25,0.5 l-1.75,1.5 l0.25,2.5 l-2,-1.25 l-2,1.25 l0.25,-2 l-1.75,-2 l2,-0.5 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_r: '<path d="M4,0.5 l1.25,2.5 l2.25,0.5 l-1.75,1.5 l0.25,2.5 l-2,-1.25 l-2,1.25 l0.25,-2 l-1.75,-2 l2,-0.5 z" fill="#fff" stroke="#333"></path>',
            dragons_marker_l: '<path d="M4,0.5 l1.25,2.5 l2.25,0.5 l-1.75,1.5 l0.25,2.5 l-2,-1.25 l-2,1.25 l0.25,-2 l-1.75,-2 l2,-0.5 z" fill="#fff" stroke="#333"></path>',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'Undefined': {
            name: '不明',
            stroke: '#999999',
            fill: '#ffffff',
            dragons_marker_r: '<path d="M1,2.5 l1,-1 l2,2 l2,-2 l1,1 l-2,2 l2,2 l-1,1 l-2,-2 l-2,2 l-1,-1 l2,-2 z" fill="#fff" stroke="#333">',
            dragons_marker_l: '<path d="M1,2.5 l1,-1 l2,2 l2,-2 l1,1 l-2,2 l2,2 l-1,1 l-2,-2 l-2,2 l-1,-1 l2,-2 z" fill="#fff" stroke="#333">',
            marker: '<circle r="3" cx="4" cy="6" fill="#fff" stroke="#000"></circle>'
        },
        'LivePitch': {
            name: '最新投球',
            stroke: '#ff0000',
            fill: '#ff0000'
        }
    },
    typesOfBall_3d: {
        // 'FourSeamFastball': {
        //     name: 'フォーシーム',
        //     stroke: '#fe37ff',
        //     fill: '#fc9fff'
        // },
        // 'OneSeamFastball': {
        //     name: 'ワンシーム',
        //     stroke: '#ff3737',
        //     fill: '#ff9f9f'
        // },
        'Fastball': {
            name: '速球',
            stroke: '#fe3737',
            fill: '#fc9f9f'
        },
        'TwoSeamFastball': {
            name: 'ツーシーム',
            fill: '#3da2f5',
            stroke: '#2196F3',
        },
        'Slider': {
            name: 'スライダー',
            stroke: '#1f5cf6',
            fill: '#6f97fa'
        },
        'Curveball': {
            name: 'カーブ',
            stroke: '#66f212',
            fill: '#a1d780'
        },
        'Splitter': {
            name: 'スプリッター',
            stroke: '#b118ff',
            fill: '#c280e2'
        },
        'ChangeUp': {
            name: 'チェンジアップ',
            stroke: '#ffa218',
            fill: '#f7e427'
        },
        'Sinker': {
            name: 'シンカー',
            stroke: '#1dc0ff',
            fill: '#5cd1e4'
        },
        'Cutter': {
            name: 'カットボール',
            stroke: '#ffc500',
            fill: '#ffb748'
        },
        'KnuckleBall': {
            name: 'ナックル',
            stroke: '#666666',
            fill: '#999999'
        },
        'Other': {
            name: 'その他',
            stroke: '#999999',
            fill: '#ffffff'
        },
        'Undefined': {
            name: '不明',
            stroke: '#999999',
            fill: '#ffffff'
        },
        'LivePitch': {
            name: '最新投球',
            stroke: '#ff0000',
            fill: '#ff0000'
        }
    },
    // フレーミング(1文字目:Framing判定, 2文字目:実際の判定)
    framingTypes: {
        'SB': {
            // 【間違ってる】フレーミング上Strike->判定Ball
            name: 'S->B',
            stroke: '#ea6191',
            fill: '#f3a5c0'
        },
        'BS': {
            // 【間違ってる】フレーミング上Ball->判定Strike
            name: 'B->S',
            stroke: '#2196F3',
            fill: '#55aef6'
        },
        'SS': {
            // 【正しい】フレーミング上Strike->判定Strike
            name: 'S->S',
            stroke: '#fdd35c',
            fill: '#fff3b8'
        },
        'BB': {
            // 【正しい】フレーミング上Ball->判定Ball
            name: 'B->B',
            stroke: '#00947a',
            fill: '#a3d6cc'
        }
    },
    // 打球速
    battingSpeedTypes: [
        {
            name: '162.3～km/h',
            min: 162.3,
            max: 200,
            stroke: '#666666',
            fill: '#ff4655'
        },
        {
            name: '155.9～162.3km/h',
            min: 155.9,
            max: 162.3,
            stroke: '#666666',
            fill: '#ff767c'
        },
        {
            name: '151.5～155.9km/h',
            min: 151.5,
            max: 155.9,
            stroke: '#666666',
            fill: '#ffadac'
        },
        {
            name: '147.4～151.5km/h',
            min: 147.4,
            max: 151.5,
            stroke: '#666666',
            fill: '#ffd6d1'
        },
        {
            name: '143.0～147.4km/h',
            min: 143.0,
            max: 147.4,
            stroke: '#666666',
            fill: '#fff8f4'
        },
        {
            name: '137.9～143.0km/h',
            min: 137.9,
            max: 143.0,
            stroke: '#666666',
            fill: '#f6ffff'
        },
        {
            name: '132.0～137.9km/h',
            min: 132.0,
            max: 137.9,
            stroke: '#666666',
            fill: '#dcf3ff'
        },
        {
            name: '124.7～132.0km/h',
            min: 124.7,
            max: 132.0,
            stroke: '#666666',
            fill: '#bedbff'
        },
        {
            name: '115.3～124.7km/h',
            min: 115.3,
            max: 124.7,
            stroke: '#666666',
            fill: '#9ab9ff'
        },
        {
            name: '102.5～115.3km/h',
            min: 102.5,
            max: 115.3,
            stroke: '#666666',
            fill: '#7595ff'
        },
        {
            name: '0～102.5km/h',
            min: 0,
            max: 102.5,
            stroke: '#666666',
            fill: '#5273ff'
        }
    ],
    // 打球角度
    battingAngleTypes: [
        {
            name: '90°～',
            min: 90,
            max: 180,
            stroke: '#666666',
            fill: '#fd1931'
        },
        {
            name: '75°～90°',
            min: 75,
            max: 90,
            stroke: '#666666',
            fill: '#ff3d4e'
        },
        {
            name: '60°～75°',
            min: 60,
            max: 75,
            stroke: '#666666',
            fill: '#ff646e'
        },
        {
            name: '45°～60°',
            min: 45,
            max: 60,
            stroke: '#666666',
            fill: '#ff9496'
        },
        {
            name: '30°～45°',
            min: 30,
            max: 45,
            stroke: '#666666',
            fill: '#ffbab8'
        },
        {
            name: '15°～30°',
            min: 15,
            max: 30,
            stroke: '#666666',
            fill: '#ffdfd9'
        },
        {
            name: '0°～15°',
            min: 0,
            max: 15,
            stroke: '#666666',
            fill: '#fff8f4'
        },
        {
            name: '-15°～0°',
            min: -15,
            max: 0,
            stroke: '#666666',
            fill: '#f8ffff'
        },
        {
            name: '-30°～-15°',
            min: -30,
            max: -15,
            stroke: '#666666',
            fill: '#e2f7ff'
        },
        {
            name: '-45°～-30°',
            min: -45,
            max: -30,
            stroke: '#666666',
            fill: '#c7e3ff'
        },
        {
            name: '-60°～-45°',
            min: -60,
            max: -45,
            stroke: '#666666',
            fill: '#accaff'
        },
        {
            name: '-75°～-60°',
            min: -75,
            max: -60,
            stroke: '#666666',
            fill: '#8aaaff'
        },
        {
            name: '-90°～-75°',
            min: -90,
            max: -75,
            stroke: '#666666',
            fill: '#7191ff'
        },
        {
            name: '～-90°',
            min: -180,
            max: -90,
            stroke: '#666666',
            fill: '#5273ff'
        }
    ],
    // 打球結果
    battingResultTypes: {
        'Single': {
            name: '安打',
            stroke: '#666666',
            fill: '#fd1931'
        },
        'Double': {
            name: '2塁打',
            stroke: '#666666',
            fill: '#ff3a4b'
        },
        'Triple': {
            name: '3塁打',
            stroke: '#666666',
            fill: '#ff5e68'
        },
        'HomeRun': {
            name: '本塁打',
            stroke: '#666666',
            fill: '#ff8a8e'
        },
        'FlyStriking': {
            name: 'フライ併殺打',
            stroke: '#666666',
            fill: '#ffb2b0'
        },
        'GrounderStriking': {
            name: 'ゴロ併殺打',
            stroke: '#666666',
            fill: '#ffd6d1'
        },
        'FlyOut': {
            name: 'フライアウト',
            stroke: '#666666',
            fill: '#5273ff'
        },
        'LinerOut': {
            name: 'ライナーアウト',
            stroke: '#666666',
            fill: '#a1c0ff'
        },
        'GrounderOut': {
            name: 'ゴロアウト',
            stroke: '#666666',
            fill: '#bedbff'
        },
        'BuntOut': {
            name: 'バントアウト',
            stroke: '#666666',
            fill: '#d9f1ff'
        },
        'FieldersChoice': {
            name: '野手選択',
            stroke: '#666666',
            fill: '#bedbff'
        },
        'Error': {
            name: 'エラー',
            stroke: '#666666',
            fill: '#98FB98'
        },
        'BuntSacrifice': {
            name: '犠牲バント',
            stroke: '#666666',
            fill: '#2E8B57'
        },
        'FlySacrifice': {
            name: '犠牲フライ',
            stroke: '#666666',
            fill: '#008000'
        },
        'Others': {
            name: 'その他',
            stroke: '#666666',
            fill: '#006400'
        }
    },
    // 打球結果（打球到達点用）
    battingResultDistanceTypes: {
        'Single': {
            name: '安打',
            stroke: '#666666',
            fill: '#fd1931'
        },
        'Double': {
            name: '2塁打',
            stroke: '#666666',
            fill: '#ff3a4b'
        },
        'Triple': {
            name: '3塁打',
            stroke: '#666666',
            fill: '#ff5e68'
        },
        'HomeRun': {
            name: '本塁打',
            stroke: '#666666',
            fill: '#ff8a8e'
        },
        'FlyOut': {
            name: 'フライアウト',
            stroke: '#666666',
            fill: '#5273ff'
        },
        'LinerOut': {
            name: 'ライナーアウト',
            stroke: '#666666',
            fill: '#a1c0ff'
        },
        'GrounderOut': {
            name: 'ゴロアウト',
            stroke: '#666666',
            fill: '#bedbff'
        },
        'BuntOut': {
            name: 'バントアウト',
            stroke: '#666666',
            fill: '#d9f1ff'
        },
        'FieldersChoice': {
            name: '野手選択',
            stroke: '#666666',
            fill: '#a1d780'
        },
        'Error': {
            name: 'エラー',
            stroke: '#666666',
            fill: '#98FB98'
        },
        'BuntSacrifice': {
            name: '犠牲バント',
            stroke: '#666666',
            fill: '#2E8B57'
        },
        'FlySacrifice': {
            name: '犠牲フライ',
            stroke: '#666666',
            fill: '#008000'
        },
        'Others': {
            name: 'その他',
            stroke: '#666666',
            fill: '#006400'
        }
    },
    // 投球速
    pitchingSpeedTypes: [
        {
            name: '160km/h～',
            min: 160,
            max: 1000,
            stroke: '#666666',
            fill: '#fd1931'
        },
        {
            name: '155～159km/h',
            min: 155,
            max: 160,
            stroke: '#666666',
            fill: '#ff525f'
        },
        {
            name: '150～154km/h',
            min: 150,
            max: 155,
            stroke: '#666666',
            fill: '#ff9496'
        },
        {
            name: '145～149km/h',
            min: 145,
            max: 150,
            stroke: '#666666',
            fill: '#ffc9c4'
        },
        {
            name: '140～144km/h',
            min: 140,
            max: 145,
            stroke: '#666666',
            fill: '#fff6f2'
        },
        {
            name: '135～139km/h',
            min: 135,
            max: 140,
            stroke: '#666666',
            fill: '#f4ffff'
        },
        {
            name: '130～134km/h',
            min: 130,
            max: 135,
            stroke: '#666666',
            fill: '#d6efff'
        },
        {
            name: '125～129km/h',
            min: 125,
            max: 130,
            stroke: '#666666',
            fill: '#a9c7ff'
        },
        {
            name: '120～124km/h',
            min: 120,
            max: 125,
            stroke: '#666666',
            fill: '#7f9eff'
        },
        {
            name: '～119km/h',
            min: 0,
            max: 120,
            stroke: '#666666',
            fill: '#5273ff'
        }
    ],
    // グラフゾーン（投球割合）
    graphZoneCourseTypes: [
        {
            name: '30%～',
            min: 30,
            max: 100,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '27%～',
            min: 27,
            max: 30,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '24%～',
            min: 24,
            max: 27,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '21%～',
            min: 21,
            max: 24,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '18%～',
            min: 18,
            max: 21,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '15%～',
            min: 15,
            max: 18,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '12%～',
            min: 12,
            max: 15,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '9%～',
            min: 9,
            max: 12,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '6%～',
            min: 6,
            max: 9,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '3%～',
            min: 3,
            max: 6,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '0%～',
            min: 0,
            max: 3,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    // グラフゾーン（打率）
    graphZoneHitTypes: [
        {
            name: '.317～',
            min: 0.317,
            max: 1,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '.305～',
            min: 0.305,
            max: 0.317,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '.294～',
            min: 0.294,
            max: 0.305,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '.287～',
            min: 0.287,
            max: 0.294,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '.281～',
            min: 0.281,
            max: 0.287,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '.274～',
            min: 0.274,
            max: 0.281,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '.268～',
            min: 0.268,
            max: 0.274,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '.263～',
            min: 0.263,
            max: 0.268,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '.255～',
            min: 0.255,
            max: 0.263,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '.245～',
            min: 0.245,
            max: 0.255,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '.0～',
            min: 0,
            max: 0.245,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    // グラフゾーン（長打率）
    graphZoneLongHitTypes: [
        {
            name: '.528～',
            min: 0.528,
            max: 10,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '.500～',
            min: 0.500,
            max: 0.528,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '.475～',
            min: 0.475,
            max: 0.500,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '.447～',
            min: 0.447,
            max: 0.475,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '.427～',
            min: 0.427,
            max: 0.447,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '.410～',
            min: 0.410,
            max: 0.427,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '.398～',
            min: 0.398,
            max: 0.410,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '.382～',
            min: 0.382,
            max: 0.398,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '.351～',
            min: 0.351,
            max: 0.382,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '.329～',
            min: 0.329,
            max: 0.351,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '.0～',
            min: 0,
            max: 0.329,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    // グラフゾーン（平均打球角度）
    graphZoneAngleTypes: [
        {
            name: '44.7～',
            min: 44.7,
            max: 180,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '32.9～',
            min: 32.9,
            max: 44.7,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '24.9～',
            min: 24.9,
            max: 32.9,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '18.8～',
            min: 18.8,
            max: 24.9,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '13.2～',
            min: 13.2,
            max: 18.8,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '7.8～',
            min: 7.8,
            max: 13.2,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '2.4～',
            min: 2.4,
            max: 7.8,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '～-3.7',
            min: -3.7,
            max: 2.4,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '～-12.7',
            min: -12.7,
            max: -3.7,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '～-28.6',
            min: -28.6,
            max: -12.7,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '-28.6～',
            min: -180,
            max: -28.6,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    graphZoneSwingSpeedTypes: [
        {
            name: '144.8～',
            min: 144.8,
            max: 145,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '122.0～',
            min: 122.0,
            max: 144.8,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '117.8～',
            min: 117.8,
            max: 122.0,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '114.6～',
            min: 114.6,
            max: 117.8,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '112.0～',
            min: 112.0,
            max: 114.6,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '109.5～',
            min: 109.5,
            max: 112.0,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '106.6～',
            min: 106.6,
            max: 109.5,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '103.5～',
            min: 103.5,
            max: 106.6,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '99.8～',
            min: 99.8,
            max: 103.5,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '93.0～',
            min: 93.0,
            max: 99.8,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '～92.9',
            min: 40.0,
            max: 93.0,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    // グラフゾーン（平均打球速）
    graphZoneSpeedTypes: [
        {
            name: '162.3～',
            min: 162.3,
            max: 180,
            stroke: '#000',
            fill: '#fd1931'
        },
        {
            name: '155.9～',
            min: 155.9,
            max: 162.3,
            stroke: '#000',
            fill: '#ff4755'
        },
        {
            name: '151.5～',
            min: 151.5,
            max: 155.9,
            stroke: '#000',
            fill: '#ff8186'
        },
        {
            name: '147.4～',
            min: 147.4,
            max: 151.5,
            stroke: '#000',
            fill: '#ffbdb9'
        },
        {
            name: '143.0～',
            min: 143.0,
            max: 147.4,
            stroke: '#000',
            fill: '#ffe5df'
        },
        {
            name: '137.9～',
            min: 137.9,
            max: 143.0,
            stroke: '#000',
            fill: '#ffffff'
        },
        {
            name: '132.0～',
            min: 132.0,
            max: 137.9,
            stroke: '#000',
            fill: '#e8faff'
        },
        {
            name: '124.7～',
            min: 124.7,
            max: 132.0,
            stroke: '#000',
            fill: '#c9e5ff'
        },
        {
            name: '115.3～',
            min: 115.3,
            max: 124.7,
            stroke: '#000',
            fill: '#9fbeff'
        },
        {
            name: '102.5～',
            min: 102.5,
            max: 115.3,
            stroke: '#000',
            fill: '#7999ff'
        },
        {
            name: '0～',
            min: 0,
            max: 102.5,
            stroke: '#000',
            fill: '#5273ff'
        }
    ],
    listOfLegend: [
        'Fastball',
        'TwoSeamFastball',
        'Slider',
        'Curveball',
        'Splitter',
        'ChangeUp',
        'Sinker',
        'Cutter',
        'KnuckleBall',
        'Other',
        'Undefined'
    ],
    typesOfResult: {
        'StrikeSwinging': {
            name: '空振ストライク'
        },
        'StrikeCalled': {
            name: '見逃しストライク'
        },
        'FoulBall': {
            name: 'ファール'
        },
        'FoulBallNotFieldable': {
            name: 'ファール'
        },
        'FoulBallFieldable': {
            name: 'ファール'
        },
        'BallCalled': {
            name: 'ボール'
        },
        'BallinDirt': {
            name: 'ボール'
        },
        'BallIntentional': {
            name: 'ボール'
        },
        'HitByPitch': {
            name: '死球'
        },
        'InPlay': {
            'FlyBall': {
                name: '外野フライ'
            },
            'Popup': {
                name: '内野フライ'
            },
            'LineDrive': {
                name: 'ライナー'
            },
            'GroundBall': {
                name: 'ゴロ'
            },
            'Bunt': {
                name: 'バント'
            },
            // 以下、PlayResult
            'Sacrifice': {
                name: '犠打'
            },
            'FieldersChoice': {
                name: '野手選択'
            },
            'Single': {
                name: '安打'
            },
            'Double': {
                name: '二塁打'
            },
            'Triple': {
                name: '三塁打'
            },
            'HomeRun': {
                name: '本塁打'
            },
            'Out': {
                name: 'アウト'
            },
            'Error': {
                name: 'エラー'
            }
        }
    },
    listOfResult: [
        'StrikeSwinging',
        'StrikeCalled',
        'FoulBall',
        'FoulBallNotFieldable',
        'FoulBallFieldable',
        'BallCalled',
        'BallinDirt',
        'BallIntentional',
        'HitByPitch',
        'FlyBall',
        'Popup',
        'LineDrive',
        'GroundBall',
        'Bunt'
    ],
    // 結果別情報（結果凡例用）
    resultsOfPitch: {
        'StrikeSwinging': {
            kind_j: '空振ストライク',
            color: '#f0725c',
            stroke: '#ED553B',
            marker: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#999"></circle>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#f0725c" stroke="#ED553B"></circle>'
        },
        'StrikeCalled': {
            kind_j: '見逃しストライク',
            color: '#f4bd57',
            stroke: '#F2B134',
            marker: '<path d="M4,1 L1,7 L7,7 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#f4bd57" stroke="#F2B134"></circle>'
        },
        'FoulBall': {
            kind_j: 'ファール',
            color: '#FFEB3B',
            stroke: '#ffe81a',
            marker: '<path d="M1,1 L7,1 L7,7, L1,7 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#FFEB3B" stroke="#ffe81a"></circle>'
        },
        'BallCalled': {
            kind_j: 'ボール',
            color: '#5dbb80',
            stroke: '#47AB6C',
            marker: '<path d="M4,1 L7,4 L4,7, L1,4 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#5dbb80" stroke="#47AB6C"></circle>'
        },
        'FlyBall': {
            kind_j: '外野フライ',
            color: '#0ddff2',
            stroke: '#0AB2C2',
            marker: '<path d="M4,1 L7,4 L5.5,7 L2.5,7 L1,4 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#0ddff2" stroke="#0AB2C2"></circle>'
        },
        'Popup': {
            kind_j: '内野フライ',
            color: '#3da2f5',
            stroke: '#2196F3',
            marker: '<path d="M1,2.5 l1,-1 l2,2 l2,-2 l1,1 l-2,2 l2,2 l-1,1 l-2,-2 l-2,2 l-1,-1 l2,-2 z" fill="#fff" stroke="#999">',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#3da2f5" stroke="#2196F3"></circle>'
        },
        'LineDrive': {
            kind_j: 'ライナー',
            color: '#5566c3',
            stroke: '#3F51B5',
            marker: '<path d="M1,1 L4,7 L7,1 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#5566c3" stroke="#3F51B5"></circle>'
        },
        'GroundBall': {
            kind_j: 'ゴロ',
            color: '#f1945b',
            stroke: '#ED7329',
            marker: '<path d="M1,5 l6,0 l0,-2 l-6,0 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#f1945b" stroke="#ED7329"></circle>'
        },
        'Bunt': {
            kind_j: 'バント',
            color: '#b3b3b3',
            stroke: '#9E9E9E',
            marker: '<path d="M4,0.5 l1.25,2.5 l2.25,0.5 l-1.75,1.5 l0.25,2.5 l-2,-1.25 l-2,1.25 l0.25,-2 l-1.75,-2 l2,-0.5 z" fill="#fff" stroke="#999"></path>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#b3b3b3" stroke="#9E9E9E"></circle>'
        },
        'HitByPitch': {
            kind_j: '死球',
            color: '#808080',
            stroke: '#666666',
            marker: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#999"></circle>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#808080" stroke="#666666"></circle>'
        },
        'Undefined': {
            kind_j: 'Undefined',
            color: '#808080',
            stroke: '#666666',
            marker: '<circle r="3" cx="4" cy="4" fill="#fff" stroke="#999"></circle>',
            dragons_marker: '<circle r="3" cx="4" cy="4" fill="#808080" stroke="#666666"></circle>'
        }
    },
    // 対戦データ点差プルダウン用（今のところ神事先生コンパネのみで使用）
    pointSpreadArray: [
        {
            'name': '-5点差以上',
            'value': '-5'
        },
        {
            'name': '-4点差',
            'value': '-4'
        },
        {
            'name': '-3点差',
            'value': '-3'
        },
        {
            'name': '-2点差',
            'value': '-2'
        },
        {
            'name': '-1点差',
            'value': '-1'
        },
        {
            'name': '同点',
            'value': '0'
        },
        {
            'name': '1点差',
            'value': '1'
        },
        {
            'name': '2点差',
            'value': '2'
        },
        {
            'name': '3点差',
            'value': '3'
        },
        {
            'name': '4点差',
            'value': '4'
        },
        {
            'name': '5点差以上',
            'value': '5'
        }
    ],
    // 結果プルダウン用
    typesOfHitType: {
        'FlyBall': {
            name: '外野フライ'
        },
        'Popup': {
            name: '内野フライ'
        },
        'LineDrive': {
            name: 'ライナー'
        },
        'GroundBall': {
            name: 'ゴロ'
        },
        'Bunt': {
            name: 'バント'
        }
    },
    listOfHitType: [
        'FlyBall',
        'Popup',
        'LineDrive',
        'GroundBall',
        'Bunt'
    ],
    typesOfPlayResult: {
        'Sacrifice': {
            name: '犠打'
        },
        'FieldersChoice': {
            name: '野手選択'
        },
        'Single': {
            name: '安打'
        },
        'Double': {
            name: '二塁打'
        },
        'Triple': {
            name: '三塁打'
        },
        'HomeRun': {
            name: '本塁打'
        },
        'Out': {
            name: 'アウト'
        },
        'Error': {
            name: 'エラー'
        }
    },
    typesOfPitchCall: {
        'StrikeSwinging': {
            name: '空振ストライク'
        },
        'StrikeSwingingZone': {
            name: '空振ストライク（ゾーン内）'
        },
        'StrikeSwingingO-Zone': {
            name: '空振ストライク（ゾーン外）'
        },
        'StrikeCalled': {
            name: '見逃しストライク'
        },
        'FoulBall': {
            name: 'ファール（ストライク）'
        },
        'BallCalled': {
            name: 'ボール'
        },
        'BallinDirt': {
            name: 'ボール'
        },
        'BallIntentional': {
            name: 'ボール'
        },
        'HitByPitch': {
            name: '死球'
        }
    },
    // typesOfPitchCallからzone、o-zoneを除いたもの
    typesOfPitchCallRealtime: {
        'StrikeSwinging': {
            name: '空振ストライク'
        },
        'StrikeCalled': {
            name: '見逃しストライク'
        },
        'FoulBall': {
            name: 'ファール'
        },
        'BallCalled': {
            name: 'ボール'
        },
        'HitByPitch': {
            name: '死球'
        }
    },
    typesOfKorBB: {
        'Strikeout': {
            name: '三振'
        },
        'Walk': {
            name: '四球'
        }
    },
    typesOfRealtimeResult: {
        'Sacrifice': {
            name: '犠打'
        },
        'FieldersChoice': {
            name: '野手選択'
        },
        'Single': {
            name: '安打'
        },
        'Double': {
            name: '二塁打'
        },
        'Triple': {
            name: '三塁打'
        },
        'HomeRun': {
            name: '本塁打'
        },
        'Out': {
            name: 'アウト'
        },
        'Out2': {
            name: 'ダブルP'
        },
        'Out3': {
            name: 'トリプルP'
        },
        'Error': {
            name: 'エラー'
        },
        'BallCalled': {
            name: 'ボール'
        },
        'FoulBall': {
            name: 'ファール'
        },
        'StrikeCalled': {
            name: '見逃しストライク'
        },
        'StrikeSwingingO-Zone': {
            name: '空振（ゾーン外）'
        },
        'StrikeSwingingZone': {
            name: '空振（ゾーン内）'
        }
    },
    // 投手ライングラフページの出し分け（今のところ神事先生コンパネのみで使用）
    pitchingConfig: {
        'speed': {
            pageTitle: 'ボールスピード（km/h）',
            graphSetting: {
                srcY: 'RelSpeed',
                con_div: 1000,
                con_mul: 1
            },
            yMin2Margin: -10,
            yMax2Margin: 10,
            yTicks2Break: 5
        },
        'spin': {
            pageTitle: 'スピンレート（rpm）',
            graphSetting: {
                srcY: 'SpinRate',
                con_div: 1,
                con_mul: 1
            },
            yMin2Margin: -200,
            yMax2Margin: 100,
            yTicks2Break: 200
        },
        'releaseHeight': {
            pageTitle: 'リリースの高さ（cm）',
            graphSetting: {
                srcY: 'RelHeight',
                con_div: 1,
                con_mul: 100
            },
            yMin2Margin: -5,
            yMax2Margin: 2,
            yTicks2Break: 5
        },
        'releaseWidth': {
            pageTitle: 'リリースの横幅（cm）',
            graphSetting: {
                srcY: 'RelSide',
                con_div: 1,
                con_mul: 100
            },
            yMin2Margin: -5,
            yMax2Margin: 2,
            yTicks2Break: 5
        },
        'releaseLength': {
            pageTitle: 'エクステンション（cm）',
            graphSetting: {
                srcY: 'Extension',
                con_div: 1,
                con_mul: 100
            },
            yMin2Margin: -10,
            yMax2Margin: 5,
            yTicks2Break: 5
        },
        'vertical': {
            pageTitle: '縦の変化量（cm）',
            graphSetting: {
                srcY: 'InducedVertBreak',
                con_div: 1,
                con_mul: 100
            },
            yMin2Margin: -20,
            yMax2Margin: 10,
            yTicks2Break: 20
        },
        'horizontal': {
            pageTitle: '横の変化量（cm）',
            graphSetting: {
                srcY: 'HorzBreak',
                con_div: 1,
                con_mul: 100
            },
            yMin2Margin: -10,
            yMax2Margin: 5,
            yTicks2Break: 10
        }
    },
    // 過去の試合 折れ線グラフ表示範囲
    pastGamesDatarange: [
        [140, 150],
        [1500, 4000],
        [0, 10],
        [20, 70],
        [0, 100],
        [170, 220],
        [150, 200],
        [1000, 6000],
        [0.25, 0.5]
    ],
    pastGamesSetting: {
        releaseSpeed: {
            name: 'ボールスピード',
            ticks: [135, 140, 145, 150, 155, 160]
        },
        spinRate: {
            name: 'スピンレート',
            ticks: [1500, 2000, 2500, 3000, 3500, 4000]
        },
        changeHorizontal: {
            name: 'ボール変化量 横',
            ticks: [0, 20, 40, 60, 80, 100]
        },
        changeVertical: {
            name: 'ボール変化量 縦',
            ticks: [0, 20, 40, 60, 80, 100]
        },
        releaseHorizontal: {
            name: 'リリースの横幅',
            ticks: [0, 20, 40, 60, 80, 100]
        },
        releaseVertical: {
            name: 'リリースの高さ',
            ticks: [170, 180, 190, 200, 210, 220]
        },
        extension: {
            name: 'エクステンション',
            ticks: [130, 150, 170, 190, 210, 230]
        },
        changeArea: {
            name: '変化面積',
            ticks: [0, 1500, 3000, 4500, 6000, 7500]
        },
        centroid_velocity: {
            name: '重心速度',
            ticks: [0, 1, 2, 3, 4, 5]
        },
        varus_torque: {
            name: '内反トルク',
            ticks: [0, 25, 50, 100, 150, 200]
        },
        energy_fa: {
            name: '前腕',
            ticks: [0, 40, 80, 120, 160, 200]
        },
        energy_lt:{
            name: '骨盤',
            ticks: [0, 60, 120, 180, 240, 300]
        },
        energy_ua: {
            name: '上腕',
            ticks: [0, 40, 80, 120, 160, 200]
        },
        energy_ut: {
            name: '胸郭',
            ticks: [0, 150, 300, 450, 600, 750]
        },
        energy_hnd: {
            name: '手+ボール',
            ticks: [0, 100, 200, 300, 400, 500]
        },
        energytransfer_fa2hnd:{
            name: '前腕→手＋ボール',
            ticks: [0, 60, 120, 180, 240, 300]
        },
        energytransfer_lt2ut:{
            name: '骨盤→胸郭',
            ticks: [0, 60, 120, 180, 240, 300]
        },
        energytransfer_ua2fa:{
            name: '上腕→前腕',
            ticks: [0, 40, 80, 120, 160, 200]
        },
        energytransfer_ut2ua:{
            name: '胸郭→上腕',
            ticks: [0, 10, 20, 30, 40, 50]
        }
    },
    // レポート用閾値自動テキスト
    thresholdTemplate: {
        'Max': ['ボールスピードMaxは', 'km/h'],
        'RelSpeed': ['のボールスピードは', 'km/h'],
        'RelSpeed_Per': ['の最高球速比が', '%'],
        'SpinRate': ['のスピンレートが', 'rpm'],
        'alpha': ['のスピン軸αが', '°'],
        'VertBreak': ['の縦成分が', 'cm'],
        'HorzBreak': ['のスライド成分が', 'cm'],
        'RelHeight': ['のリリースの高さが', 'cm'],
        'RelSide': ['のリリースの横幅が', 'cm'],
        'Extension': ['のエクステンションが', 'cm']
    },
    // MLB、NPB球変換（スカウト用）
    ballTypeExchange: {
        NPBtoMLB: {
            InducedVertBreak: {
                plus: 0.95,
                minus: 0.95
            },
            HorzBreak: {
                plus: 0.95,
                minus: 0.95
            }
        },
        MLBtoNPB: {
            InducedVertBreak: {
                plus: 1.05,
                minus: 1.05
            },
            HorzBreak: {
                plus: 1.05,
                minus: 1.05
            }
        }
    },
    realtimeGameGameInfoUUID: 'bd2368ce-2648-4bd8-bb41-bac5bac5bac5',
    realtimeGameGameInfoTime: '2099-01-01T00:00:00.00000000Z',
    errorMessage: {
        'API': {
            // 0：通信不可
            'E90000': 'ネットワークに接続できません。<br>通信状態の良い場所に移動するか、<br>少し時間を置いてページをリロードして下さい。<br>（エラーコード：E90000）',
            // 400：Bad Request（クエリパラメータの不正他）
            'E90400': '情報の取得に失敗しました。<br>（エラーコード：E90400）',
            // 401:Unauthorized
            'E90401': '利用できないtokenです。<br>メニューからログアウトして、<br>再度ログインしてください。<br>（エラーコード：E90401）',
            // 401:Unauthorized（ログインエラー）
            'E90401b': 'ログインIDかパスワードが違います<br>（エラーコード：E90401b）',
            // 403：権限なし
            'E90403': '情報を取得する権限がありません。<br>（エラーコード：E90403）',
            // 404:Not Found
            'E90404': '情報の取得に失敗しました。<br>（エラーコード：E90404）',
            // 上記以外のエラー
            'E90499': '情報の取得に失敗しました。<br>（エラーコード：E90499）'
        },
        'MQTT': {
            // MQTT接続エラー
            'EMQ000': 'MQTTサーバーに接続できませんでした。<br>インターネット環境を確認して下さい。<br>接続できたら画面をリロードしてください。<br>（エラーコード：EMQ000）',
            // MQTTブルペンディスプレイ用ログインエラー
            'EMQ001': 'MQTTサーバーに接続できませんでした。<br>右上のボタンからログイン画面に戻り<br>設定で入力した内容を見直すか、<br>インターネット環境を確認し、ログインし直して下さい。<br>（エラーコード：EMQ001）'
        }
    },
    sessionKey: {
        pichiTunnelBase: 'PichiTunnelBase', // ピッチトンネルローカルストレージ基準球キー名
        pichiTunnelCompar: 'PichiTunnelCompare', // ピッチトンネルローカルストレージ比較球キー名
        pt1Tabs: 'PT1Tabs', // PT1 タブデータ保存キー名
        pt2Ball1: 'PT2Ball1', // PT2の投球1 キー名
        pt2Ball2: 'PT2Ball2', // PT2の投球2 キー名
        pt2: 'PT2', // PT2で保存されるキー名
        pt2Search: 'PT2Search', // PT2検索用コンポーネントで保存されるキー名
        pt2SearchTmp: 'PT2SearchTmp', // PT2検索用コンポーネントtmp
        pt2HomeBallContent: 'PT2HomeBallContent', // PT2ゾーン選択用コンポーネントで保存されるキー名
        pt2ConfirmationChangeAmountBall1: 'PT2ConfirmationChangeAmountBall1', // PT2中央グラフで使用する投球1
        pt2ConfirmationChangeAmountBall2: 'PT2ConfirmationChangeAmountBall2', // PT2中央グラフで使用する投球1
        pt2ChangeAmountThresholdSeekBar: 'PT2ChangeAmountThresholdSeekBar', // PT2変化量決定の際の閾値
        pt2S1ThresholdSeekBar: 'PT2S1ThresholdSeekBar', // PT2閾値決定の際の閾値
        pt2SSelectedBall1: 'PT2SSelectedBall1', // PT2Sの選択された投球1
        pt2SSelectedBall2: 'PT2SSelectedBall2', // PT2Sの選択された投球2
        pt3From: 'PT3from', // PT3遷移時に、PT2SかPT2Hどちらから来たか　 Sなら閾値、Hなら変化量
        fromPT2: 'FromPT2', // PT2からPT1に遷移したかどうか
        pt2ComparisonReviewData: 'PT2ComparisonReviewData'
    },
    startYear: 2017
}
